import { createReducer } from '@reduxjs/toolkit';

import { IFilter } from '../filters/types';

import { dictFilterLoad } from './actions';

interface IDictsReducer {
  filters: Partial<IFilter[]>;
}

const initialState: IDictsReducer = {
  filters: [],
};

export default createReducer(initialState, (builder) => {
  builder.addCase(dictFilterLoad, (state, action) => ({
    ...state,
    filters: action.payload,
  }));
});
